<h1>{{ dogName }} - dokumentumai</h1>
<app-documents
  [entityId]="dogId"
  [documentTypes]="dogDocumenTypes"
  [allDocuments]="allDocuments"
  storageCollectionName="dogs"
  [deleteDocumentOnUpload]="true"
  (onRefresh)="refreshDocuments()"
></app-documents>
